import type { CancelablePromise } from "../client"
import { OpenAPI } from "../client"
import { request as __request } from "../client/core/request"

export type CreateProcurementRequestDTO = {
  warehouse_id?: string
  description?: string
  items: Array<{ product_id: string; requested_qty: number; comment?: string }>
}
export type InitProcurementRequestDraftDTO = {
  warehouse_id: string
  description?: string
}
export type UpdateProcurementRequestDTO = {
  warehouse_id?: string | null
  description?: string | null
  items: Array<{
    id?: string
    product_id: string
    requested_qty: number
    comment?: string
  }>
}

export type ProcurementRequestListItemDTO = {
  id: string
  number: string
  status: string
  created_at: string
  warehouse_id?: string | null
  warehouse_code?: string | null
  progress: number
  created_by: string
  created_by_id: string
}

export type ProcurementRequestDetailDTO = {
  id: string
  number: string
  status: string
  description?: string
  created_at: string
  updated_at?: string | null
  confirmed_at?: string | null
  cancelled_at?: string | null
  warehouse?: { id: string; code: string; name: string } | null
  realized_items_count: number
  total_items_count: number
  requested_qty_sum: number
  ordered_qty_sum: number
  owner: { id: string; name: string; acronym: string }
  items: Array<{
    id: string
    requested_qty: number
    comment?: string
    ordered_qty: number
    remaining_qty: number
    product: { id: string; sku: string; name: string; unit: string }
  }>
  linked_zz: Array<{
    id: string
    number: string
    status: string
    created_at: string
  }>
}

export type CreateZZFromProcurementRequestDTO = {
  supplier_id: string
  items: Array<{ request_item_id: string; qty_to_order: number }>
}

export const ProcurementRequestsService = {
  initDraft: (
    requestBody: InitProcurementRequestDraftDTO,
  ): CancelablePromise<{ id: string; number: string; status: string }> =>
    __request(OpenAPI, {
      method: "POST",
      url: "/v1/procurement-requests/drafts",
      body: requestBody,
      mediaType: "application/json",
    }),

  create: (
    requestBody: CreateProcurementRequestDTO,
  ): CancelablePromise<{ id: string; number: string; status: string }> =>
    __request(OpenAPI, {
      method: "POST",
      url: "/v1/procurement-requests",
      body: requestBody,
      mediaType: "application/json",
    }),

  getAll: (
    year?: number,
    month?: number,
  ): CancelablePromise<ProcurementRequestListItemDTO[]> =>
    __request(OpenAPI, {
      method: "GET",
      url: "/v1/procurement-requests",
      query: { year, month },
    }),

  getByID: (id: string): CancelablePromise<ProcurementRequestDetailDTO> =>
    __request(OpenAPI, {
      method: "GET",
      url: "/v1/procurement-requests/{id}",
      path: { id },
    }),
  updateByID: (
    id: string,
    requestBody: UpdateProcurementRequestDTO,
  ): CancelablePromise<{ id: string; number: string; status: string }> =>
    __request(OpenAPI, {
      method: "PATCH",
      url: "/v1/procurement-requests/{id}",
      path: { id },
      body: requestBody,
      mediaType: "application/json",
    }),

  deleteByID: (id: string): CancelablePromise<void> =>
    __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/procurement-requests/{id}",
      path: { id },
    }),

  confirmByID: (
    id: string,
  ): CancelablePromise<{ id: string; number: string; status: string }> =>
    __request(OpenAPI, {
      method: "POST",
      url: "/v1/procurement-requests/{id}/confirm",
      path: { id },
    }),

  cancelByID: (
    id: string,
  ): CancelablePromise<{ id: string; number: string; status: string }> =>
    __request(OpenAPI, {
      method: "POST",
      url: "/v1/procurement-requests/{id}/cancel",
      path: { id },
    }),

  createZZByID: (
    id: string,
    requestBody: CreateZZFromProcurementRequestDTO,
  ): CancelablePromise<{ id: string; number: string; status: string }> =>
    __request(OpenAPI, {
      method: "POST",
      url: "/v1/procurement-requests/{id}/create-zz",
      path: { id },
      body: requestBody,
      mediaType: "application/json",
    }),
}
